<div
  #infoNotification
  class="info-notification-wrapper"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  aria-label="Info Notification"
  role="button"
  tabindex="0"
  aria-live="polite"
>
  <div class="icon-border-timer">
    <svg *ngIf="autoClose" class="progress-ring" width="48" height="48">
      <circle class="progress-ring-circle" stroke-width="2" fill="transparent" r="14" cx="24" cy="21" />
    </svg>
    <mat-icon fontSet="material-icons-round" class="info-notification-icon">{{ matIcon }}</mat-icon>
  </div>
  <div class="info-notification-content">
    <header *ngIf="title" class="info-notification-content-header">
      <span class="info-notification-content-header-title ods-typography-body-m-bold">{{ title | translate }}</span>
      <button
        *ngIf="closeButton"
        class="info-notification-content-header-close"
        mat-icon-button
        (click)="onClose()"
        aria-label="Close"
      >
        <mat-icon fontSet="material-icons-round">close</mat-icon>
      </button>
    </header>
    <main class="info-notification-content-body ods-typography-body-m-regular">
      {{ message | translate }}
    </main>
  </div>
</div>
